import Bugsnag from '@bugsnag/js';

export const appVersion = '1.0.3';
export const bugsnagClient = Bugsnag.start({
  apiKey: '99dc63130d0452fec54315a31a5523bd',
  appVersion,
  enabledReleaseStages: ['production'],
});
